module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mgm mgmindex"
  }, [_c('div', {
    staticClass: "mgm-bg"
  }, [_c('img', {
    staticStyle: {
      "visibility": "hidden",
      "position": "absolute"
    },
    attrs: {
      "src": _vm.ilogSrc
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "m-b-1"
  }), _vm._v(" "), _c('div', {
    staticClass: "m-b-2"
  }, [_c('div', {
    staticClass: "register-box"
  }, [_c('div', {
    staticClass: "enter"
  }, [_c('div', {
    staticClass: "phone"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.phone),
      expression: "phone"
    }],
    attrs: {
      "placeholder": "请输入手机号",
      "maxLength": "11",
      "type": "tel"
    },
    domProps: {
      "value": (_vm.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.phone = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "code"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.code),
      expression: "code"
    }],
    attrs: {
      "maxLength": "6",
      "placeholder": "请输入验证码",
      "type": "tel"
    },
    domProps: {
      "value": (_vm.code)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.code = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    attrs: {
      "data-ilog": "14.1504.pP0"
    },
    on: {
      "click": _vm.getCode
    }
  }, [_vm._v(_vm._s(_vm.codeMsg))])]), _vm._v(" "), _c('button', {
    staticClass: "apply",
    attrs: {
      "data-ilog": "14.1504.fH3"
    },
    on: {
      "click": _vm.shareHandle
    }
  })])])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "m-b-4"
  }), _vm._v(" "), _c('div', {
    staticClass: "m-b-5"
  })]), _vm._v(" "), _c('toast', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isToast),
      expression: "isToast"
    }]
  }, [_vm._t("default", [_vm._v(_vm._s(_vm.toastMsg))])], 2), _vm._v(" "), _c('loading', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLoading),
      expression: "isLoading"
    }]
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "m-b-3"
  }, [_c('div', {
    staticClass: "event-header"
  }), _vm._v(" "), _c('div', {
    staticClass: "event-text"
  }, [_c('p', [_vm._v("1. "), _c('b', [_vm._v("活动时间：")])]), _vm._v(" "), _c('p', [_vm._v("2017年即日起-2017年12月21日 23:59分")]), _vm._v(" "), _c('p', [_vm._v("2. "), _c('b', [_vm._v("奖品：")]), _vm._v("58元点点免息券。")]), _vm._v(" "), _c('p', [_vm._v("3. "), _c('b', [_vm._v("获奖条件：")]), _vm._v("新用户下载登录点点APP，完成申请并获得授信额度即可获得奖品。")]), _vm._v(" "), _c('p', [_vm._v("4. "), _c('b', [_vm._v("奖品使用：")]), _vm._v("点点免息券在提现时可抵用同等金额利息，具体使用方法详见 我的优惠券-免息券使用说明。")]), _vm._v(" "), _c('p', [_vm._v("5. "), _c('b', [_vm._v("奖品效期：")]), _vm._v("30天，包括领券日当天。超过有效期未使用免息券则自动失效。")]), _vm._v(" "), _c('p', [_vm._v("6. 本次活动最终解释权归深圳众联商务所有。")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2e4ac798"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/mgmindex.vue
// module id = 193
// module chunks = 0